export default "__VITE_ASSET__a6Eue5oH__"